"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RADIO_STATES = exports.RADIO_DOT_STATES = void 0;

var _themeGet = require("@styled-system/theme-get");

var _styledComponents = require("styled-components");

var RADIO_DOT_STATES = {
  default: {
    resting: (0, _styledComponents.css)(["border:2px solid;color:", ";border-color:", ";"], (0, _themeGet.themeGet)("colors.white100"), (0, _themeGet.themeGet)("colors.black10")),
    selected: (0, _styledComponents.css)(["border:2px solid;color:", ";border-color:", ";background-color:", ";"], (0, _themeGet.themeGet)("colors.white100"), (0, _themeGet.themeGet)("colors.black100"), (0, _themeGet.themeGet)("colors.black100"))
  },
  disabled: {
    resting: (0, _styledComponents.css)(["border:2px solid;color:transparent;border-color:", ";background-color:", ";"], (0, _themeGet.themeGet)("colors.black10"), (0, _themeGet.themeGet)("colors.black10")),
    selected: (0, _styledComponents.css)(["border:2px solid;color:", ";border-color:", ";background-color:", ";"], (0, _themeGet.themeGet)("colors.white100"), (0, _themeGet.themeGet)("colors.black10"), (0, _themeGet.themeGet)("colors.black10"))
  },
  error: {
    resting: (0, _styledComponents.css)(["border:2px solid;color:", ";border-color:", ";"], (0, _themeGet.themeGet)("colors.white100"), (0, _themeGet.themeGet)("colors.red100")),
    selected: (0, _styledComponents.css)(["border:2px solid;color:", ";border-color:", ";background-color:", ";"], (0, _themeGet.themeGet)("colors.white100"), (0, _themeGet.themeGet)("colors.black100"), (0, _themeGet.themeGet)("colors.black100"))
  },
  hover: {
    resting: (0, _styledComponents.css)(["border:2px solid;color:", ";border-color:", ";background-color:", ";"], (0, _themeGet.themeGet)("colors.white100"), (0, _themeGet.themeGet)("colors.black10"), (0, _themeGet.themeGet)("colors.black10")),
    selected: (0, _styledComponents.css)(["border:2px solid;color:", ";border-color:", ";background-color:", ";"], (0, _themeGet.themeGet)("colors.white100"), (0, _themeGet.themeGet)("colors.black100"), (0, _themeGet.themeGet)("colors.black100"))
  }
};
exports.RADIO_DOT_STATES = RADIO_DOT_STATES;
var RADIO_STATES = {
  default: (0, _styledComponents.css)(["color:", ";"], (0, _themeGet.themeGet)("colors.black100")),
  hover: (0, _styledComponents.css)(["color:", ";"], (0, _themeGet.themeGet)("colors.black100")),
  disabled: (0, _styledComponents.css)(["pointer-events:none;color:", ";"], (0, _themeGet.themeGet)("colors.black30")),
  error: (0, _styledComponents.css)(["color:", ";"], (0, _themeGet.themeGet)("colors.red100"))
};
exports.RADIO_STATES = RADIO_STATES;
//# sourceMappingURL=v2.js.map